import styled from '@emotion/styled';
import { Css, ShimmerPlaceholder } from '../../../../../../ui';

export const TextPlaceholder = styled(ShimmerPlaceholder)<{ width?: string }>`
	width: ${({ width }) => width || '80%'};
	height: 1.2rem;
	margin-bottom: ${Css.pxToRem(12)};
`;
